(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('ConfigAccessOnuController', ConfigAccessOnuController);

    ConfigAccessOnuController.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'OnuData', 'OnuService', 'onuItem'];

    function ConfigAccessOnuController($rootScope, $scope, $uibModalInstance, OnuData, OnuService, onuItem) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;
        vm.dataOnu = {
            id: onuItem.id,
            oltName: onuItem.oltName,
            name: onuItem.name,
            meProfile: onuItem.meProfile,
            gponPort: onuItem.gponPort,
            gponSlot: onuItem.gponSlot,
            accessUser: onuItem.accessUser,
            accessPassword: onuItem.accessPassword
        };

        // Method handler
        vm.close = close;
        vm.save = save;

        // Method handler
        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        // Method API
        function save() {
            if (vm.formConfigAccessOnu.$valid && !vm.requestRunning) {
                var data = {
                    id: vm.dataOnu.id,
                    accessUser: vm.dataOnu.accessUser,
                    accessPassword: vm.dataOnu.accessPassword
                };
                vm.requestRunning = true;
                OnuService.saveOnuCredentials(data)
                        .then(successSave)
                        .catch(errorSave);
            }
        }

        // Method request
        function successSave(data) {
            vm.requestRunning = false;
            OnuService.successModalConstructor('credentials');
            $rootScope.$emit('onuUpdateSuccess', data);
        }

        function errorSave(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'credentials');
        }

    }

})();
